// CENTRALIZED affiliate link config. Change tags/regions here only.
// V1 = retailer search URLs + tracking tag. Amazon is region-locked
// (.ca vs .com); Amazon OneLink can later auto-localize at runtime.
import type { Region } from '../lib/region'
import type { Locale } from '../i18n/locale'

export interface RetailerLink {
  name: string
  url: string
  color: string
}

// Amazon Associates tracking IDs. Region-locked: .ca tag only works on amazon.ca,
// .com tag only works on amazon.com. Visitor region is auto-detected (see lib/region.ts).
const AMAZON = {
  ca: { domain: 'www.amazon.ca', tag: 'renosheets-20' },
  us: { domain: 'www.amazon.com', tag: 'renosheetsusa-20' },
}

// Amazon-only for now. Home Depot (Impact) and Lowe's (CJ) affiliate programs
// aren't approved yet, so showing them earns nothing and just clutters the
// "Where to buy" section. Re-add the entries here once approved — visitor
// region is auto-detected (see lib/region.ts) and Amazon.ca takes a
// `language=fr_CA` query param for French-Canadian visitors.
export function getAffiliateLinks(
  productName: string,
  region: Region,
  locale: Locale = 'en',
): RetailerLink[] {
  const q = encodeURIComponent(productName)
  const az = AMAZON[region]
  const amazonLang = region === 'ca' && locale === 'fr' ? '&language=fr_CA' : ''
  return [
    { name: 'Amazon', url: `https://${az.domain}/s?k=${q}&tag=${az.tag}${amazonLang}`, color: '#FF9900' },
  ]
}
